import { makeRequest } from '../client'

export const getMenuByMerchantId = async (restaurantId) =>
  makeRequest('menu', 'getMenuByRestaurant', { restaurantId });

export const getMenuCategories = async (restaurantId) =>
  makeRequest('menu', 'getMenuCategories', { restaurantId });

export const getMenuItemsByCategory = async (restaurantId, categoryId) =>
  makeRequest('menu', 'getMenuItems', { restaurantId, categoryId });

export const menuItemsByMerchant = async (restaurantId) =>
  makeRequest('menu', 'getMenuByRestaurant', { restaurantId });
